import { useState, useEffect } from 'react'

export function useSessionStorage<T>(key: string, initialValue: T | (() => T)) {
    const getStoredValue = () => {
        const item = sessionStorage.getItem(key)
        if (item !== null) return JSON.parse(item) as T

        return initialValue instanceof Function ? initialValue() : initialValue
    }

    const [value, setValue] = useState<T>(getStoredValue)

    useEffect(() => {
        setValue(getStoredValue())
    }, [key])

    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(value))
    }, [JSON.stringify(value)])

    return [value, setValue] as const
}
